module.exports = __webpack_public_path__ + "img/grand-vitara-deep-blue.f154b4d3.png";